
export default "/assets/bigcommerce.be9bb36a.svg"